import { Flex, Spinner, Text } from '@chakra-ui/react'
import { forwardRef } from 'react'
import { Button } from '../../../components/Button'

export const MaisClientes = forwardRef((props, ref) => {
    return (
        <>
            <Flex justify="center">
                <Button ref={ref} onClick={() => props.fetchNextPage()} disabled={!props.hasNextPage || props.isFetchingNextPage}>
                    {props.isFetchingNextPage ? (
                        <Flex alignItems="center" justifyContent="center" gap={2}>
                            <Text>Carregando mais clientes...</Text>
                            <Spinner size="sm" />
                        </Flex>
                    ) : props.hasNextPage ? (
                        'Carregar mais clientes'
                    ) : (
                        'Não há mais clientes'
                    )}
                </Button>
            </Flex>
            <div>{props.isFetching && !props.isFetchingNextPage ? 'Buscando mais clientes...' : null}</div>
        </>
    )
})
